document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');
    if (!doubleuspsElement) return;

    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays);

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;

    const cstmDate = document.getElementById('cstmdate');
    if (cstmDate) cstmDate.innerText = dataFormattata;

    const mezzanotte = new Date(ora);
    mezzanotte.setHours(24, 0, 0, 0);
    setTimeout(aggiornaData, mezzanotte - ora);
  }

  aggiornaData();
});




document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.u-os-swiper').forEach(function (slider) {
    new Swiper(slider, {
      slidesPerView: Number(slider.dataset.mobile),
      spaceBetween: Number(slider.dataset.mobileGap),

      breakpoints: {
        768: {
          slidesPerView: Number(slider.dataset.tablet),
          spaceBetween: Number(slider.dataset.gap)
        },
        1024: {
          slidesPerView: Number(slider.dataset.desktop),
          spaceBetween: Number(slider.dataset.gap)
        }
      },

      pagination: {
        el: slider.querySelector('.u-os-pagination'),
        clickable: true
      }
    });
  });
});

